import Api from './api';

export default class ShoppingCartController {
    constructor() {
        // Shopping cart page
        this.container = null;
        this.form = null;
        this.submitTimer = null;
        this.waitingTime = 500;

        // Adding to the cart + managing shopping cart in header
        this.api = new Api();
        this.headerShoppingCart = null;

        this.init();
    }

    init() {
        if (document.querySelector('section.shoppingCart')) {
            this.container = document.querySelector('section.shoppingCart');
            this.form = this.container.querySelector('form');
        }

        if (document.querySelector('header .shoppingCartButton')) {
            this.headerShoppingCart = document.querySelector('header .shoppingCartButton');
            this.updateHeaderCart();
        }
        
        this.setEventListeners();
    }

    setEventListeners() {
        if (this.container) {
            this.container.querySelectorAll('.items li').forEach(product => {
                const quantityInput = product.querySelector('.quantityInput');
                const deleteButton = product.querySelector('.deleteColumn button');
    
                deleteButton.addEventListener('click', e => {
                    e.preventDefault();
                    this.confirmDelete(product);
                });
    
                quantityInput.addEventListener('update', e => {
                    if (quantityInput.querySelector('input').value == 0) {
                        this.confirmDelete(product);
                    } else {
                        this.submit();
                    }
                });
            });
        }

        document.querySelectorAll('.addProductButton[data-product-node-id]').forEach(productButton => {
            productButton.addEventListener('click', e => {
                e.preventDefault();
                this.api.addProductToCart(productButton.dataset.productNodeId).then(result => {
                    this.updateHeaderCart().finally(() => {
                        if (result == 'OK') {
                            window.app.toast('Product toegevoegd!');
                            this.playCartAnimation();
                        } else if (result == 'NO') {
                            window.app.toast('Product niet toegevoegd; maximum bereikt', 'warning');
                        } else {
                            window.app.toast('Er is iets misgegaan met het toevoegen, probeer het later nog eens', 'error');
                        }
                    });
                }).catch(e => {
                    window.app.toast('Er is iets misgegaan met het toevoegen, probeer het later nog eens', 'error');
                    console.error(e);
                });
            });
        });
    }

    confirmDelete(product) {
        const quantityInput = product.querySelector('.quantityInput');
        let confirmText = this.form.dataset.confirmText || 'Weet jezeker dat je dit product uit je winkelmandje wilt verwijderen?';
        
        if (confirm(confirmText)) {
            quantityInput.querySelector('input').value = 0;
            this.form.submit(); // Delete is confirmed, so submit instantly instead of waiting for user input
        } else {
            if (quantityInput.querySelector('input').value == 0) {
                quantityInput.querySelector('input').value = 1;
                this.submit();
            }

            return false;
        }
    }

    submit() {
        if (this.submitTimer) {
            clearTimeout(this.submitTimer);
        }
        this.submitTimer = setTimeout(() => {
            this.form.submit();
        }, this.waitingTime);
    }

    updateHeaderCart() {
        return this.api.getShoppingCart().then(data => {
            if (data.totalItemCount !== undefined) {
                this.headerShoppingCart.querySelector('text').innerHTML = data.totalItemCount;

                if (data.totalItemCount > 0) {
                    this.headerShoppingCart.classList.remove('d-none');
                } else {
                    this.headerShoppingCart.classList.add('d-none');
                }
            }

            return true;
        }).catch(e => {
            console.log('Something went wrong with updating the shopping cart');
            console.error(e);
        });
    }

    playCartAnimation() {
        if (this.headerShoppingCart) {
            let div = document.createElement('div');
            div.classList.add('update');
            this.headerShoppingCart.appendChild(div);

            setTimeout(() => {
                div.remove();
            }, 1200);
        }
    }
}